// Set loader
const LOGIN = state => {
  state.loading = true
}

// Manage Login success
const LOGIN_SUCCESS = (state, token) => {
  state.token = token // Save token in store
  state.loading = false // Stop loader
  state.error = false // No error => false
}

// Manage Login error
const LOGIN_ERROR = (state) => {
  state.token = '' // Remove token in store
  state.loading = false // Stop loader
  state.error = true // Error(s) => true
}

// Manage Logout
const LOGOUT = state => {
  state.token = ''
}

export default {
  LOGIN,
  LOGIN_SUCCESS,
  LOGIN_ERROR,
  LOGOUT
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/mutations.js